<template>
  <div v-if="detour">
    <General @detour="ecranDetourage()"/>
  </div>
  <div v-else>
    <Detourage  @finPopUp="ecranSuivant()"/>
    
  </div>
</template>

<script>
import Detourage from "@/components/Configuration/Detourage.vue";
import General from "@/components/Configuration/General.vue";
import backend from "@/api/backend";
// import api from "@/api/api";

export default {
  components: { Detourage, General},

  mounted(){
    try {
      backend.get_edges_install(this.installation_id);
      this.detour = true;      
    }
    catch(err){
      this.detour=false;
    }
    //recup contour si contour general sinon detourage
    
  },

  data() {
    return {
      installation_id: this.$route.params.id,
      detour: false,
    }
  },

  methods: {
    ecranSuivant(){
        this.detour = true;
    },

    ecranDetourage(){
      this.detour = false;
    }
    }
}
</script>
  
<style scoped>
  .small-map {
    height: 800px;
    width:100%;
    aspect-ratio: 1 / 1;
    z-index: 0;   
  }

  .title2{
      font-size: 40px;
  }

  .texte{
    margin-top:10%;
    font-size: 20px;
  }
</style>
